import {
    Button,
    Flex,
    MOBILE_TOP_NAV_HEIGHT_FULL_LOGO,
    useStyles,
} from '@archipro-design/aria';
import * as S from './VariantPOA.mobile.style';
import SaveToDesignBoard from '~/modules/design-board/component/SaveToDesignBoard';
import type { PrimaryCTAResult } from '~/modules/professional/util/professional-cta-helper';
import { useFavouriteVariant } from '../../hook/use-favourite-variant';
import { COMPANY_ENQUIRY_FORM_ANCHOR } from '~/modules/company-profile/CompanyProfile';
import { WhereToBuyButton } from '../product-details/WhereToBuyButton';
import { useVariantSelectionState } from '../../context/VariantSelectionContext';
import { useSampleStock } from '../../hook/use-sample-stock';
import type Product from '@modules/product/type/product';

interface VariantPOAProps {
    itemID: number;
    professional: {
        title: string;
        id: number;
    };
    primaryCTA?: PrimaryCTAResult;
    isInServiceableArea: boolean;
    whereToBuyEnabled?: boolean;
    onClickWhereToBuy?: () => void;
    product: Product;
}

const VariantPOA = (props: VariantPOAProps) => {
    const {
        itemID,
        primaryCTA,
        isInServiceableArea,
        whereToBuyEnabled,
        onClickWhereToBuy,
        product,
    } = props;
    const favouriteItem = useFavouriteVariant(itemID);
    const { css } = useStyles();
    const { selectedVariant } = useVariantSelectionState();
    const { canPurchase: sampleCanPurchase } = useSampleStock(selectedVariant);
    const hasShippingMethods = selectedVariant?.SampleShippingProfile
        ?.NoShipping
        ? false
        : (selectedVariant?.SampleShippingProfile?.ShippingMethods ?? [])
              .length > 0;
    const pickupLocations = product.Professional.PickupLocations;
    const hasSampleShippingOptions =
        hasShippingMethods || pickupLocations.length > 0;

    return (
        <>
            <div className={css(S.Container)}>
                {isInServiceableArea ? (
                    <div className={css(S.Wrapper)}>
                        <Button
                            size={16}
                            fluid
                            variables={{
                                iconPadding: 0,
                                buttonPadding: 0,
                            }}
                            onClick={() => {
                                window.scrollTo({
                                    top:
                                        (document.getElementById(
                                            COMPANY_ENQUIRY_FORM_ANCHOR
                                        )?.offsetTop ?? 0) -
                                        MOBILE_TOP_NAV_HEIGHT_FULL_LOGO,
                                    behavior: 'smooth',
                                });
                            }}
                        >
                            {(
                                primaryCTA?.primaryCTALabel ?? `REQUEST PRICE`
                            ).toUpperCase()}
                        </Button>
                    </div>
                ) : (
                    <div></div>
                )}
                {isInServiceableArea && (
                    <Flex gap="space-20" className={css(S.SaveShareContainer)}>
                        <SaveToDesignBoard
                            heartButton={{
                                className: css(S.ButtonHeart),
                                color: 'primary',
                                variables: {
                                    iconPadding: 0,
                                    buttonPadding: 0,
                                    primaryNoBKGButtonBackgroundColorHover:
                                        'transparent',
                                },
                                size: 20,
                            }}
                            {...favouriteItem}
                        />
                    </Flex>
                )}
            </div>
            {whereToBuyEnabled &&
                (!sampleCanPurchase || !hasSampleShippingOptions) && (
                    <Flex>
                        <WhereToBuyButton onClick={onClickWhereToBuy} />
                    </Flex>
                )}
        </>
    );
};

export default VariantPOA;
